// extracted by mini-css-extract-plugin
export default {"tooltip-anchor":"low-resolution-tooltip_tooltip-anchor__zaDGC","tooltip-trigger":"low-resolution-tooltip_tooltip-trigger__sAv9z"};